import LegalDocumentPage from "./LegalDocumentPage";

function PrivacyPolicyPage() {
  return (
    <LegalDocumentPage
      documentType="privacy"
      title="Política de privacidad"
      description="Consulta cómo Wiblo recopila, utiliza, protege y administra la información de sus usuarios."
    />
  );
}

export default PrivacyPolicyPage;